const { REACT_APP_ENDPOINT = '' } = (window?._env_ ?? {})
//NOTE -  Launch QR Portal
// http://localhost:3000/merchantportal/QrAgentLogin

const Linking = {
  prefixes: ['http://localhost:3000/', 'localhost://'],
  config: {
    screens: {
      login: {
        screens: {
          login: `${REACT_APP_ENDPOINT}/login`,
        },
      },
      otp: `${REACT_APP_ENDPOINT}/otp`,
      root: {
        path: `${REACT_APP_ENDPOINT}/`,
        screens: {
          dashboard: {
            screens: {
              home: '/',
              supersetDashboard: 'analyticalDashboard/:dashboardId',
            },
          },
        },
      },
      // dashboard: {
      //   screens: {
      //     dashboard: {
      //       screens: {
      //         dashboard: '/dashboard',
      //         EditUserRole: {
      //           path: 'edit-user-role',
      //         },
      //       },
      //     },
      //   },
      // },
      //root: `${REACT_APP_ENDPOINT}/`,
      QrAgentPortal: {
        screens: {
          QrAgentLogin: `${REACT_APP_ENDPOINT}/agent/login`,
          QrAgentOtp: `${REACT_APP_ENDPOINT}/agent/otp`,
          status: `${REACT_APP_ENDPOINT}/agent/status`,
          review: `${REACT_APP_ENDPOINT}/agent/review`,
          scanqr: `${REACT_APP_ENDPOINT}/agent/scanqrcode`,
          midslist: `${REACT_APP_ENDPOINT}/agent/midlist`,
        },
      },
      marketing: {
        screens: {
          jiopay: '/jiopay',
        },
      },
      setting: '/setting',
      '/jiopay/contact': '/jiopay/contact',
      forgotPassword: `${REACT_APP_ENDPOINT}/forgot-password`,
      resetPassword: `${REACT_APP_ENDPOINT}/reset-password`,
      signup: '/signup',
      step2: '/step2',
      step3: 'step3',
      transactions: '/transactions',
      settlements: '/settlements',
      'initiate-refunds': '/initiate-refunds',
      disputes: '/disputes',
      refunds: '/refund-reports',
      '/support': 'support',
      '/faqs': '/faqs',
      contact: 'contact-us',
      '/agreement': '/agreement',
      '/tnc': '/tnc',
      '/privacy': '/privacy',
      number: '/number',
      email: '/email',
      profile: '/profile',
      password: '/password',
      upgrade: '/upgrade',
      'pay-settle': '/pay-settle',
      documents: '/documents',
      notifications: '/notifications',
      invoices: '/invoices',
      '/transactions/initiate-refunds': '/transactions/initiate-refunds',
      '/refunds/initiate-refunds': '/refunds/initiate-refunds',
      '/home/initiate-refunds': '/home/initiate-refunds',
      AddNewUser: 'add-new-user',
      bulkrefund: '/bulk-refund',
      CreatePaymentLink: '/create-payment-link',
      paymentlinks: 'payment-links',
      'reports/transaction': 'reports/transaction',
      'reports/settlement': 'reports/settlement',
      'reports/refund': 'reports/refund',
      '/campaigns/createcampaign': '/campaigns/createcampaign',
      '/campaigns/details': '/campaigns/details',
      payoutsbeneficiary: '/payoutsbeneficiary',
    },
  },
}

export default Linking
